import { render, staticRenderFns } from "./FormEdit.vue?vue&type=template&id=551d1f0a&"
import script from "./FormEdit.vue?vue&type=script&lang=js&"
export * from "./FormEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('551d1f0a')) {
      api.createRecord('551d1f0a', component.options)
    } else {
      api.reload('551d1f0a', component.options)
    }
    module.hot.accept("./FormEdit.vue?vue&type=template&id=551d1f0a&", function () {
      api.rerender('551d1f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/reporting-channel/handling/FormEdit.vue"
export default component.exports